<template>
  <div class="market-layout">
    <b-row class="no-gutters">
      <b-col lg="8" class="col">
        <sub-header type="market" />

        <b-row class="no-gutters">
          <b-col cols="12" md="4" class="instruments-bar-wrapper" :class="{'d-none': this.$route.name !== `${market.slug}.instruments`}">
            <instruments-bar />
          </b-col>

          <b-col class="content" :class="{'no-instruments-bar': this.$route.name !== `${market.slug}.instruments`}">
            <router-view />
          </b-col>
        </b-row>
      </b-col>

      <b-col class="intraday" :class="{'intraday-mobile-open': !is_mobile_content_opened, 'show': is_mobile_menu_opened}">
        <div>
          <b-tabs fill>
            <b-tab v-if="is_mobile">
              <template v-slot:title>
                <h4 @click="toggle_menu" class="d-flex justify-content-end">
                  <div class="intraday-updates-icon-wrapper" style="width: 70px" >
                    <i class="fas fa-bars"></i>
                  </div>
                </h4>
              </template>
            </b-tab>

            <b-tab  :active="!market.disable_intraday_updates" v-if="!market.disable_intraday_updates && (!is_mobile || is_mobile_menu_opened)" @click="open_mobile_content()">
              <template v-slot:title>
                <div class="d-flex">
                  <div class="d-block d-lg-none flex-shrink-0 d-flex justify-content-center" style="width: 60px;">
                    <div class="intraday-updates-icon-wrapper">
                      <img :src="user_theme ? intraday_image_dark : intraday_image" alt="Intraday Updates">
                      <div class="unread-intraday-updates"></div>
                    </div>
                  </div>

                  <h4 class="flex-grow-1 d-flex" :class="is_mobile ? 'justify-content-start' : 'justify-content-center'">
                    {{ market.intraday_updates_tab_label }}
                  </h4>
                </div>
              </template>

              <intraday-updates-list :isMobileMenuOpen="is_mobile_content_opened" @close-mobile-menu="close_mobile_content($event)"/>
            </b-tab>

            <b-tab :active="market.disable_intraday_updates" v-if="!market.disable_reports && (!is_mobile || is_mobile_menu_opened)" @click="open_mobile_content()">
              <template v-slot:title>
                <div class="d-flex">
                  <div class="d-block d-lg-none flex-shrink-0 d-flex justify-content-center" style="width: 60px;">
                    <div class="intraday-updates-icon-wrapper">
                      <img class="p-0" width="14px" :src="user_theme ? report_image_dark : report_image" alt="Reports">
                    </div>
                  </div>

                  <h4 class="flex-grow-1 d-flex" :class="is_mobile ? 'justify-content-start' : 'justify-content-center'">
                    {{ $t('layouts.default.reports') }}
                  </h4>
                </div>
              </template>

              <reports-list :isMobileMenuOpen="is_mobile_content_opened" @close-mobile-menu="close_mobile_content()"/>
            </b-tab>

            <b-tab class="h-100" :active="market.disable_reports && market.disable_intraday_updates" v-if="!market.disable_news && (!is_mobile || is_mobile_menu_opened)" @click="open_mobile_content()">
              <template v-slot:title>
                <div class="d-flex">
                  <div class="d-block d-lg-none flex-shrink-0 d-flex justify-content-center" style="width: 60px;">
                    <div class="intraday-updates-icon-wrapper">
                      <i class="fas fa-newspaper"></i>
                    </div>
                  </div>

                  <h4 class="flex-grow-1 d-flex" :class="is_mobile ? 'justify-content-start' : 'justify-content-center'">
                    {{ $t('layouts.default.news') }}
                  </h4>
                </div>
              </template>

              <news-content :isMobileMenuOpen="is_mobile_content_opened" @close-mobile-menu="close_mobile_content()"></news-content>
            </b-tab>

            <b-tab content-class="d-block d-lg-none slack-tab" v-if="!market.disable_slack && (!is_mobile || is_mobile_menu_opened)" @click="open_mobile_content()">
              <template v-slot:title>
                <div class="d-flex">
                  <div class="d-block d-lg-none flex-shrink-0 d-flex justify-content-center" style="width: 60px;">
                    <div class="intraday-updates-icon-wrapper">
                      <i class="fab fa-slack"></i>
                    </div>
                  </div>

                  <h4 class="flex-grow-1 d-flex" :class="is_mobile ? 'justify-content-start' : 'justify-content-center'">
                    {{ $t('layouts.default.slack_channel') }}
                  </h4>
                </div>
              </template>

              <slack-channel :isMobileMenuOpen="is_mobile_content_opened" @close-mobile-menu="close_mobile_content()"></slack-channel>
            </b-tab>

          </b-tabs>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SubHeader from '../../components/SubHeader.vue'
import InstrumentsBar from '../../components/market/InstrumentsBar.vue'
import IntradayUpdatesList from '../../components/intraday_updates/List.vue'
import ReportsList from '../../components/reports/List.vue'
import SlackChannel from '../../components/market/SlackChannel.vue'
import { mapState } from 'vuex'
import NewsContent from '../../components/market/NewsContent.vue'

export default {
  name: 'MarketLayout',
  components: {
    SubHeader,
    InstrumentsBar,
    IntradayUpdatesList,
    ReportsList,
    SlackChannel: SlackChannel,
    NewsContent: NewsContent
  },
  data () {
    return {
      is_mobile: window.matchMedia('(max-width: 991.98px)').matches,
      is_mobile_content_opened: true,
      is_mobile_menu_opened: false,
      market: Object,
      intraday_image: '/img/intraday.svg',
      intraday_image_dark: '/img/intraday-dark.svg',
      report_image: '/img/report.svg',
      report_image_dark: '/img/report-dark.svg'
    }
  },
  computed: {
    ...mapState({
      current_user: state => state.profile.account.current_user,
      user_theme: state => state.user_theme.user_theme,
      markets: state => state.market.markets
    })
  },
  mounted () {
    this.$store.dispatch('dynamic_contents/load_dynamic_contents')

    const that = this
    this.$store.dispatch('market/loadMarkets').then(() => {
      that.market = that.markets.find(market => market.slug === that.$route.matched[0].meta.market)
    })

    window.addEventListener('resize', this.check_resize)
  },
  methods: {
    check_resize () {
      this.is_mobile = window.matchMedia('(max-width: 991.98px)').matches
    },
    open_mobile_content () {
      this.is_mobile_content_opened = false
    },
    close_mobile_content (close_menu) {
      this.is_mobile_content_opened = true
      if (close_menu) this.toggle_menu()
    },
    toggle_menu () {
      this.is_mobile_menu_opened = !this.is_mobile_menu_opened
    }
  }
}
</script>

<style scoped lang="scss">
.market-layout {
  // @include layout-with-sticky-header;
  background-color: var(--white-black);
}

.instruments-bar-wrapper {
  max-width: 150px;
  height: calc(100vh - 140px);
  overflow-y: auto;

  @media (max-width: 575.98px) {
    width: 100%;
    max-width: 100%;
  }
}

.content {
  height: calc(100vh - 140px);
  overflow-y: auto;
  overflow-x: hidden;

  @media (max-width: 991.98px) {
    position: fixed;
    width: calc(100% - 150px);
    z-index: 100;
    background-color: var(--white-black);
    left: 150px;
    top: 140px;
    bottom: 0;

    &.no-instruments-bar {
      width: 100%;
      left: 0;
    }
  }

  @media (max-width: 575.98px) {
    width: 100%;
    left: 0;
  }
}

.intraday {
  background-color: var(--pale-grey-two-charcoal-grey-two);
  z-index: 1;
  border-left: 1px solid var(--ice-blue-charcoal-grey-three);

  &.intraday-mobile-open {
    z-index: 200;
  }

  ::v-deep .nav-tabs {
    border-bottom: 1px solid var(--ice-blue-charcoal-grey-three);
    line-height: 70px;

    .nav-item {
      text-align: center;
      margin-bottom: 0;
    }

    .nav-link {
      color: var(--muted-blue-dark-sky-blue);
      font-size: 14px;
      border: 0;
      border-radius: 0;
      padding: 0;
      position: relative;

      h4 {
        font-size: 14px;
        line-height: inherit;
        margin-bottom: 0;
      }

      .intraday-updates-icon-wrapper {
        width: 50px;
        position: relative;
      }

      .unread-intraday-updates {
        width: 6px;
        height: 6px;
        background-color: var(--coral-pink);
        border-radius: 100%;
        top: 20px;
        right: 5px;
        position: absolute;
      }

      &.active {
        background-color: initial;
        color: var(--muted-blue-dark-sky-blue);
      }

      &:before,
      &:after {
        position: absolute;
        transition: all 0.35s ease;
      }

      &:after {
        bottom: 0;
        left: 0;
        display: block;
        height: 3px;
        width: 0%;
        content: '';
        background-color: var(--muted-blue-dark-sky-blue);
      }

      &:hover:after,
      &.active:after {
        opacity: 1;
        width: 100%;
      }

      &:hover:after,
      &.active:after {
        max-width: 100%;
      }
    }

    @media (max-width: 991.98px) {
      .nav-item {
        width: 100%;

        img {
          padding: 18px;
        }

        &.slack-tab {
          display: none;
        }

        .nav-link:after {
          width: 0;
        }
      }
    }
  }

  ::v-deep .tab-content {
    height: calc(100vh - 140px);
    overflow-y: auto;

    .content-wrapper {
      height: 100%;

      @media (max-width: 991.98px) {
        position: fixed;
        width: 100%;
        max-width: 100%;
        z-index: 300;
        overflow-y: scroll;
        height: 100%;
        left: 0;
        top: 0;
        background-color: var(--pale-grey-two-charcoal-grey-two);
      }
    }

    .updates-header {
      padding: 0 25px 0 30px;

      h3 {
        font-size: 14px;
        color: var(--muted-blue-dark-sky-blue);
        font-family: 'Heebo', arial, sans-serif;
        font-weight: 500;
        text-transform: uppercase;
        line-height: 57px;
        margin-bottom: 0;

        span {
          font-weight: 300;
          font-family: 'Montserrat', arial, sans-serif;
          text-transform: initial;
        }
      }

      h4 {
        cursor: pointer;
        font-size: 11px;
        color: var(--muted-blue);
        font-family: 'Montserrat', arial, sans-serif;
        font-weight: 400;
        text-transform: uppercase;
        line-height: 57px;
        margin-bottom: 0;
        text-align: right;

        @media (min-width: 1200px) {
          img {
            margin-right: 8px;
            margin-top: -3px
          }
        }
      }

      .dropdown-icon-wrapper {
        position: relative;
        top: 1px;
      }

      @media (max-width: 991.98px) {
        padding: 0 20px 0 20px;

        .col {
          padding-left: 0;
        }

        h4 {
          text-transform: initial;
          color: var(--cool-grey);
          font-weight: 300;

          span {
            font-weight: 600;
            margin-right: 5px;
          }
        }
      }
    }

    .updates-filter {
      padding: 30px 25px 0 30px;
      position: absolute;
      width: 100%;
      z-index: 300;
      overflow-y: scroll;
      height: calc(100vh - 140px);
      top: 70px;
      background-color: var(--pale-grey-two);

      h3 {
        font-size: 16px;
        color: var(--battleship-grey);
        font-weight: 300;
      }

      span {
        @include basic-transition;
        color: var(--cool-grey);
        opacity: .5;
        font-size: 17px;
        cursor: pointer;

        &:hover {
          opacity: .25;
        }
      }

      h4 {
        font-size: 14px;
        color: var(--cool-grey);
        margin: 45px 0 25px 0;
        font-weight: 300;
      }

      .btn {
        background-color: var(--muted-blue);
        margin-top: 35px;
        height: 50px;
        min-width: 152px;
      }
    }

    .updates {
      ul {
        list-style: none;
        padding: 0;
        margin: 0;
      }

      li.search {
        input {
          width: 100%;
          border: none;
          padding: 0 30px;
          margin: 0;
          font-size: 14px;
          font-weight: 300;
          color: var(--cloudy-blue);
          line-height: 56px;
          background-color: var(--pale-grey-two-charcoal-grey-two);

          &::placeholder {
            color: var(--cloudy-blue);
          }

          @media (max-width: 991.98px) {
            padding: 0 20px;
          }
        }
      }

      .overlay-content {
        height: auto;
        max-height: 104px;
        overflow: hidden;
        @include ease-transition(1s);

        &.active {
          max-height: 100vh;
          margin-bottom: 20px;

          .overlay-buttons {
            background-image: none;
          }
        }

        .overlay-buttons {
          position: absolute;
          bottom: 0;
          padding: 38px 0 18px;
          width: 100%;
          left: 0;
          font-size: 11px;
          background-image: linear-gradient(to bottom, #f5f8fa00, var(--pale-grey-two-charcoal-grey-two) 59%);

          a {
            cursor: pointer;
            color: var(--muted-blue);
          }
        }
      }

      li.update {
        padding: 20px 25px 25px 30px;
        border-bottom: 1px solid var(--ice-blue-three-charcoal-grey-three);
        position: relative;

        &:empty {
          border-bottom: 0;
        }

        &.instrument {
          visibility: hidden;
          opacity: 0;
          transition: visibility 0s, opacity 0.5s linear;

          &.instrument-visible {
            visibility: visible;
            opacity: 1;
          }
        }

        &.trading-notes-and-instruments {
          padding-top: 0;
          padding-bottom: 0;

          p {
            padding: 13px 0;
          }

          a {
            display: inline-block;
            font-family: 'Montserrat', arial, sans-serif;
            font-weight: 400;
            cursor: pointer;

            &:hover {
              color: var(--muted-blue);
            }
          }

          span:not(:first-child):not(:empty)::before {
            content: ', ';
          }

          span:empty + span:not(:empty)::before {
            content: '';
          }

          span:not(:empty) ~ span:empty + span:not(:empty)::before {
            content: ', ';
          }
        }

        .top-part {
          margin-bottom: 10px;
        }

        h5 {
          font-size: 15px;
          color: var(--charcoal-grey-white);
          display: inline-block;
          margin-right: 9px;
        }

        .market-icon {
          margin-top: -3px;
          margin-right: 4px;
        }

        p {
          font-size: 14px;
          font-family: 'Athelas', arial, sans-serif;
          letter-spacing: 0.08px;
          color: var(--charcoal-grey-white);
          line-height: 1.46;
          margin: 0;
        }

        .col {
          text-align: right;

          small,
          ::v-deep .v-time-ago__text {
            font-size: 12px;
          }

          .intraday-image {
            margin-top: 15px;
            position: relative;
            cursor: pointer;

            &:first-child {
              margin-top: 0;
            }

            img {
              height: auto;
              width: 80px;
            }

            .image-overlay {
              position: absolute;
              top: 0;
              right: 0;
              width: 80px;
              height: 100%;
              background-color: var(--white-70);
              border: 1px solid var(--blue-grey-30);
              text-align: left;
              padding-left: 8px;

              h6 {
                font-size: 11px;
                margin-bottom: 0;
                width: 75%;
                margin-top: 5px;
                color: var(--flat-blue-two);
                text-transform: uppercase;
              }

              small,
              ::v-deep .v-time-ago__text {
                font-size: 11px;
                color: var(--flat-blue-two);
                position: absolute;
                bottom: 1px;
              }

              .graph-zoom-icon {
                width: 18px;
                min-height: 18px;
                max-height: 18px;
                position: absolute;
                bottom: 0;
                right: 0;
              }

              &:hover {
                .graph-zoom-icon {
                  opacity: .8;
                }
              }
            }

            @media (min-width: 1200px) and (max-width: 1400px) {
              .col {
                padding-left: 0;
              }
              img {
                width: 75px;
              }

              .image-overlay {
                width: 75px;
              }
            }
          }
        }

        @media (max-width: 991.98px) {
          padding: 20px 20px 25px;
        }

        @media (min-width: 1200px) and (max-width: 1400px) {
          .col {
            padding-left: 0;
          }
        }

        @media (max-width: 1199.98px) and (min-width: 992px) {
          .col .intraday-image {
            display: inline-block;
            margin-right: 10px;

            &:first-child {
              margin-top: 15px;
            }

            &:last-child {
              margin-right: 0;
            }
          }
        }

        @media (max-width: 360px) {
          .col {
            padding-left: 0;
          }
        }
      }
    }
  }
}

.slack {
  a {
    font-size: 50px;
  }
}

.slack-dynamic-content {
  padding: 25px 25px 9px;
  border-top: 1px solid var(--ice-blue-three-charcoal-grey-three);

  h4 {
    color: var(--blueberry);
    margin-bottom: 20px;
    font-size: 20px;
  }

  div {
    font-size: 13px;
  }
}

@media (max-width: 991.98px) {
  .intraday.col {
    flex: 0 0 70px;
    transition: flex-basis 0.3s ease;
    height: calc(100vh - 70px);
    overflow: hidden;
  }

  .intraday.col.show {
    flex: 0 0 250px;
    z-index: 100;
  }
}
</style>
